import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {BaseService} from 'src/app/services/base.service';

@Injectable({providedIn: 'root'})

export class SelectMessageService extends BaseService {
  list(query?: any) {
    const httpOptions = {
      params: query
    };
    return this.get<any>('/brand-name/templates', httpOptions);
  }

  listBrandName() {
    return this.get<any>('/brand-name');
  }
}
